export const tagStyles = {
  tagContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '1px 6px',
    width: 'fit-content',
    gap: '4px',
    borderRadius: '8px',
    border: '1px solid #F3F4F9',
    maxHeight: '24px',
    label: {
      padding: '0',
      '& svg': {
        width: '16px',
        height: '16px',
      },
    },
  },
  tagInnerText: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '146%',
    color: '#23252F',
  },
};
